/* NZS-RVF-0905 / NZS-RVF2-0906: NZ Supps review popup, product + store modes, three steps (rating > review > about you),
 * the same pages as Judge.me's own modal but on the quick-add shell (.nzs-qa / .nzs-qa-bd, bottom sheet on touch, centred
 * modal on desktop, blurred backdrop, nzsOverlay focus trap). Loaded sitewide (theme.liquid, defer).
 * Opens from: [data-nzs-review-open] buttons (PDP reviews section), window.nzsReviewForm.open({store:true}), or a deep link
 * ?nzs_review=product|store (+ judgeme_token = verified-buyer token from Judge.me emails, e= / n= prefill).
 * Posts multipart to Judge.me's public create endpoint exactly like their widget (shop params + rating/name/email/body +
 * id, token when present; store reviews = id 0 + judgeme_review_source=store-review-collection). Sub-ratings ride in the
 * body as a last line "Flavour 5/5 · Effectiveness 4/5 · Value 5/5" that the reviews section renders as mini star rows.
 * ponytail: whole stars only (Judge.me stores integers), no photo upload (URL-only API), no custom-question ids. */
(function () {
  'use strict';
  if (window.__nzsRvf) return; window.__nzsRvf = 1;
  var MQ = '(max-width:760px), (hover:none) and (pointer:coarse)';
  var STAR = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.6l2.9 6.2 6.8.8-5 4.7 1.3 6.7L12 17.7 6 21l1.3-6.7-5-4.7 6.8-.8z"/></svg>';
  var CHEV = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 18l-6-6 6-6" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var MARK = 'https://cdn.shopify.com/s/files/1/0746/2220/6150/files/nzs-logo-black-email.png?v=1788485612';
  var ROWS = [['flavour', 'Flavour'], ['effect', 'Effectiveness'], ['value', 'Overall value']];
  var HINTS = ['', 'Not for me', 'Could be better', 'Decent', 'Really good', 'Love it'];
  var bd, panel, overlay, meta = {}, val = {}, step = 1, advTimer = 0;

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function q(sel) { return panel.querySelector(sel); }
  function stars(k, label) {
    var h = '<div class="nzs-rvf__stars" role="radiogroup" aria-label="' + esc(label) + '" data-k="' + k + '">';
    for (var i = 1; i <= 5; i++) h += '<button type="button" role="radio" aria-checked="false" data-v="' + i + '" aria-label="' + i + (i === 1 ? ' star' : ' stars') + '">' + STAR + '</button>';
    return h + '</div>';
  }
  function build() {
    if (panel) return;
    bd = document.createElement('div'); bd.className = 'nzs-qa-bd nzs-rvf-bd';
    panel = document.createElement('div'); panel.className = 'nzs-qa nzs-rvf';
    document.body.appendChild(bd); document.body.appendChild(panel);
    bd.addEventListener('click', close);
    panel.addEventListener('click', onClick);
    panel.addEventListener('mouseover', onHover);
    panel.addEventListener('mouseout', onHover);
    panel.addEventListener('keydown', onKey);
    panel.addEventListener('submit', onSubmit);
    if (window.nzsOverlay && window.nzsOverlay.enhance) {
      overlay = window.nzsOverlay.enhance({
        root: panel, key: 'review-form', label: 'Leave a review',
        onOpen: function () { bd.classList.add('is-in'); panel.classList.add('is-in'); },
        onClose: function () { bd.classList.remove('is-in'); panel.classList.remove('is-in'); }
      });
    }
  }
  function render() {
    val = {}; step = 1;
    var store = meta.store;
    var card = store
      ? '<div class="nzs-rvf__card nzs-rvf__card--store"><img class="nzs-rvf__mark" src="' + MARK + '" alt="NZ Supps"></div>'
      : '<div class="nzs-rvf__card">' + (meta.image ? '<img class="nzs-rvf__thumb" src="' + esc(meta.image) + '" alt="">' : '') +
        '<div><div class="nzs-rvf__ct">' + esc(meta.title) + '</div>' + (meta.variant ? '<div class="nzs-rvf__cv">' + esc(meta.variant) + '</div>' : '') + '</div></div>';
    panel.innerHTML =
      '<button type="button" class="nzs-qa__close" aria-label="Close"><span class="nzs-qa__close-x">&#10005;</span></button>' +
      '<div class="nzs-rvf__dots" aria-hidden="true"><i class="is-on"></i><i></i><i></i>' + (store ? '' : '<i></i>') + '</div>' +
      '<form class="nzs-qa__body nzs-rvf__form" novalidate>' +
        '<section class="nzs-rvf__page" data-step="1">' +
          '<h3 class="nzs-rvf__h">' + (store ? 'How would you rate NZ Supps?' : 'How would you rate this product?') + '</h3>' +
          '<p class="nzs-rvf__sub">' + (store ? 'Delivery, the site, the people. Tap a star.' : 'Tap a star. Twenty seconds, and it helps the next person pick right.') + '</p>' +
          card +
          '<div class="nzs-rvf__overall">' + stars('rating', 'Overall rating') +
            '<div class="nzs-rvf__ends" aria-hidden="true"><span>Poor</span><span>Great</span></div>' +
            '<span class="nzs-rvf__hint" data-hint aria-live="polite"></span></div>' +
        '</section>' +
        '<section class="nzs-rvf__page" data-step="2" hidden>' +
          '<h3 class="nzs-rvf__h">' + (store ? 'How was the experience?' : 'What did you think of it?') + '</h3>' +
          '<label class="nzs-rvf__lab">Your review<textarea class="nzs-rvf__in nzs-rvf__ta" name="body" rows="5" maxlength="5000" required placeholder="' + (store ? 'Fast, slow, easy, confusing. Say it how it was.' : 'Flavour, how it worked, whether it was worth it.') + '"></textarea></label>' +
          '<p class="nzs-rvf__err" data-err role="alert" hidden></p>' +
          '<div class="nzs-rvf__foot"><button type="button" class="nzs-rvf__back" data-back>' + CHEV + 'Back</button><button type="button" class="nzs-rvf__go nzs-rvf__go--sm" data-next>Next</button></div>' +
        '</section>' +
        '<section class="nzs-rvf__page" data-step="3" hidden>' +
          '<h3 class="nzs-rvf__h">About you</h3>' +
          '<div class="nzs-rvf__two">' +
            '<label class="nzs-rvf__lab">Name<input class="nzs-rvf__in" name="name" type="text" maxlength="80" required autocomplete="name" value="' + esc(meta.name) + '"></label>' +
            '<label class="nzs-rvf__lab">Email<input class="nzs-rvf__in" name="email" type="email" maxlength="120" required autocomplete="email" value="' + esc(meta.email) + '"></label>' +
          '</div>' +
          '<p class="nzs-rvf__fine">Your email stays private. Reviews are checked before they show.</p>' +
          '<p class="nzs-rvf__err" data-err role="alert" hidden></p>' +
          '<div class="nzs-rvf__foot"><button type="button" class="nzs-rvf__back" data-back>' + CHEV + 'Back</button>' +
            (store ? '<button type="submit" class="nzs-rvf__go nzs-rvf__go--sm">Post review</button>' : '<button type="button" class="nzs-rvf__go nzs-rvf__go--sm" data-next>Next</button>') + '</div>' +
        '</section>' +
        (store ? '' : '<section class="nzs-rvf__page" data-step="4" hidden>' +
          '<h3 class="nzs-rvf__h">A couple of quick questions</h3>' +
          '<p class="nzs-rvf__sub">Tap what fits. Skip any you are not sure about.</p>' +
          '<div class="nzs-rvf__rows nzs-rvf__rows--sm">' + ROWS.map(function (r) { return '<div class="nzs-rvf__row"><span>' + r[1] + '</span>' + stars(r[0], r[1]) + '</div>'; }).join('') + '</div>' +
          '<p class="nzs-rvf__err" data-err role="alert" hidden></p>' +
          '<div class="nzs-rvf__foot"><button type="button" class="nzs-rvf__back" data-back>' + CHEV + 'Back</button><button type="submit" class="nzs-rvf__go nzs-rvf__go--sm">Post review</button></div>' +
        '</section>') +
      '</form>';
  }
  function go(n) {
    step = n;
    var pages = panel.querySelectorAll('[data-step]');
    for (var i = 0; i < pages.length; i++) pages[i].hidden = Number(pages[i].getAttribute('data-step')) !== n;
    var dots = panel.querySelectorAll('.nzs-rvf__dots i');
    for (var j = 0; j < dots.length; j++) dots[j].classList.toggle('is-on', j < n);
    var f = n === 2 ? q('textarea') : n === 3 ? (meta.name ? q('[name=email]') : q('[name=name]')) : n === 4 ? q('[data-step="4"] .nzs-rvf__stars button[tabindex="0"]') : q('.nzs-rvf__stars button[tabindex="0"]');
    if (f) f.focus({ preventScroll: true });
    q('.nzs-qa__body').scrollTop = 0;
  }
  function paint(group) {
    var k = group.getAttribute('data-k'), v = val[k] || 0, hv = Number(group.getAttribute('data-hover') || 0), show = hv || v;
    var bs = group.querySelectorAll('button');
    for (var i = 0; i < bs.length; i++) {
      bs[i].classList.toggle('is-on', i < show);
      bs[i].setAttribute('aria-checked', i + 1 === v ? 'true' : 'false');
      bs[i].tabIndex = (v ? i + 1 === v : i === 0) ? 0 : -1;
    }
    if (k === 'rating') { var hint = q('[data-hint]'); if (hint) hint.textContent = HINTS[show] || ''; }
  }
  function pick(g, n) {
    var k = g.getAttribute('data-k'); val[k] = n; g.setAttribute('data-hover', ''); paint(g);
    if (k === 'rating' && step === 1) { clearTimeout(advTimer); advTimer = setTimeout(function () { if (step === 1) go(2); }, 260); }
  }
  function onHover(e) {
    if (!window.matchMedia('(hover:hover)').matches) return;
    var g = e.target.closest && e.target.closest('.nzs-rvf__stars'); if (!g) return;
    var b = e.target.closest('.nzs-rvf__stars button');
    g.setAttribute('data-hover', e.type === 'mouseover' && b ? b.getAttribute('data-v') : ''); paint(g);
  }
  function onClick(e) {
    var b = e.target.closest('.nzs-rvf__stars button');
    if (b) { pick(b.parentNode, Number(b.getAttribute('data-v'))); return; }
    if (e.target.closest('[data-next]')) {
      if (step === 2) { if (!q('textarea').value.trim()) return fail(q('[data-step="2"] [data-err]'), 'Write a sentence or two first.'); go(3); return; }
      var f3 = q('form'); if (!f3.name.value.trim() || !f3.email.checkValidity()) return fail(q('[data-step="3"] [data-err]'), 'Add your name and a valid email.'); go(4); return;
    }
    if (e.target.closest('[data-back]')) { go(step - 1); return; }
    if (e.target.closest('.nzs-qa__close') || e.target.closest('[data-done]')) close();
  }
  function onKey(e) {
    var g = e.target.closest && e.target.closest('.nzs-rvf__stars');
    if (!g) return;
    var d = { ArrowRight: 1, ArrowUp: 1, ArrowLeft: -1, ArrowDown: -1 }[e.key];
    if (e.key === 'Enter' && g.getAttribute('data-k') === 'rating' && val.rating) { e.preventDefault(); go(2); return; }
    if (!d) return;
    e.preventDefault();
    var k = g.getAttribute('data-k'), n = Math.min(5, Math.max(1, (val[k] || 0) + d));
    val[k] = n; paint(g); g.querySelectorAll('button')[n - 1].focus();
  }
  function fail(err, msg) { if (err) { err.textContent = msg; err.hidden = false; } }
  function shopParams() {
    try { if (window.jdgm && window.jdgm.shopParams) return window.jdgm.shopParams(); } catch (x) {}
    var sd = (window.Shopify && window.Shopify.shop) || location.hostname;
    return { url: sd, shop_domain: sd, platform: 'shopify' };
  }
  function onSubmit(e) {
    e.preventDefault();
    var f = e.target, err = q('[data-step="' + step + '"] [data-err]') || q('[data-err]'), goBtn = f.querySelector('[type=submit]');
    err.hidden = true;
    if (!val.rating) { go(1); return; }
    if (!f.body.value.trim()) { go(2); return; }
    if (!f.name.value.trim() || !f.email.checkValidity()) return fail(err, 'Add your name and a valid email.');
    var subs = meta.store ? [] : ROWS.filter(function (r) { return val[r[0]]; }).map(function (r) { return (r[0] === 'effect' ? 'Effectiveness' : r[0] === 'value' ? 'Value' : 'Flavour') + ' ' + val[r[0]] + '/5'; });
    var body = f.body.value.trim() + (subs.length ? '\n\n' + subs.join(' · ') : '');
    var p = shopParams(), fd = new FormData();
    Object.keys(p).forEach(function (k) { fd.append(k, p[k]); });
    fd.append('rating', val.rating); fd.append('name', f.name.value.trim()); fd.append('email', f.email.value.trim());
    fd.append('title', ''); fd.append('body', body); fd.append('reviewer_name_format', '');
    fd.append('id', meta.store ? '0' : meta.pid);
    if (meta.store) fd.append('judgeme_review_source', 'store-review-collection');
    if (meta.token) fd.append('token', meta.token);
    goBtn.disabled = true; goBtn.textContent = 'Posting…';
    fetch('https://api.judge.me/api/v1/reviews', { method: 'POST', body: fd })
      .then(function (r) { return r.ok ? r : r.text().then(function (t) { throw new Error(t || r.status); }); })
      .then(function () {
        q('.nzs-qa__body').innerHTML =
          '<div class="nzs-rvf__done"><div class="nzs-rvf__tick">' + STAR + '</div><h3>Thanks, ' + esc(f.name.value.trim().split(' ')[0]) + '!</h3>' +
          '<p>' + (meta.store ? 'Your store review is in.' : 'Your review is in.') + ' It shows once it has been checked.</p><button type="button" class="nzs-rvf__go" data-done>Done</button></div>';
        panel.querySelector('.nzs-rvf__dots').hidden = true;
        q('[data-done]').focus();
      })
      .catch(function (x) { goBtn.disabled = false; goBtn.textContent = 'Post review'; fail(err, /verif/i.test(x.message) ? 'Please verify your email with the link we just sent, then post again.' : 'That did not go through. Please try again in a moment.'); });
  }
  function urlp(k) { try { return new URLSearchParams(location.search).get(k) || ''; } catch (x) { return ''; } }
  /* open(triggerElement) for product mode, open({store:true}) for store mode; e/n/judgeme_token URL params fill in either */
  function open(t) {
    build();
    var el = t && t.getAttribute ? t : null, o = el ? {} : (t || {});
    meta = {
      store: !!o.store, pid: el ? el.getAttribute('data-pid') : (o.pid || '0'),
      title: el ? el.getAttribute('data-title') : (o.title || ''), image: el ? el.getAttribute('data-image') : (o.image || ''),
      variant: el ? (el.getAttribute('data-variant') || '') : (o.variant || ''),
      name: (el && el.getAttribute('data-name')) || o.name || urlp('n'), email: (el && el.getAttribute('data-email')) || o.email || urlp('e'),
      token: urlp('judgeme_token')
    };
    render();
    var m = window.matchMedia(MQ).matches;
    panel.classList.toggle('is-sheet', m); panel.classList.toggle('nzs-qa--modal', !m);
    if (overlay) overlay.open({ trigger: el || undefined }); else { bd.classList.add('is-in'); panel.classList.add('is-in'); }
    panel.querySelectorAll('.nzs-rvf__stars').forEach(paint);
    go(1);
  }
  function close() { clearTimeout(advTimer); if (overlay) overlay.close(); else { bd.classList.remove('is-in'); panel.classList.remove('is-in'); } }
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-nzs-review-open]');
    if (t) { e.preventDefault(); open(t.getAttribute('data-nzs-review-open') === 'store' ? { store: true, name: t.getAttribute('data-name') || '', email: t.getAttribute('data-email') || '' } : t); }
  });
  /* deep link: ?nzs_review=store on any page, ?nzs_review=product on a PDP (falls back to store off a PDP); hides Judge.me's modal */
  var want = urlp('nzs_review');
  if (want) {
    document.documentElement.setAttribute('data-nzs-rvf', '1');
    var start = function () {
      var t = want === 'product' && document.querySelector('[data-nzs-review-open]:not([data-nzs-review-open="store"])');
      open(t || { store: true });
    };
    if (document.readyState === 'complete') start(); else window.addEventListener('load', start);
  }
  window.nzsReviewForm = { open: open, close: close };
})();
